// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LanguageSelection from './components/LanguageSelection';
import UserInfoForm from './components/UserInfoForm';
import AssessmentIntro from './components/AssessmentIntro';
import AssessmentQuiz from './components/AssessmentQuiz';
import ResultSubmission from './components/ResultSubmission';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LanguageSelection />} />
        
        {/* 原有企业人力资源测评入口 (隐式 type="adult14_hr") */}
        <Route path="/interview" element={<UserInfoForm type="adult14_hr" />} />
        
        {/* 新增通用成人测评入口 */}
        <Route path="/adult14" element={<UserInfoForm type="adult14" />} />

        {/* 兒童7心座測評入口 */}
        <Route path="/child7" element={<UserInfoForm type="child7" />} />

        {/* 青春版(青少年14心座)測評入口 */}
        <Route path="/youth" element={<UserInfoForm type="youth" />} />

        {/* 多元智能测评入口 */}
        <Route path="/intelligent" element={<UserInfoForm type="intelligent" />} />

        {/* 暂未实现的其他路由，后续添加 */}

        <Route path="/intro" element={<AssessmentIntro />} />
        <Route path="/quiz" element={<AssessmentQuiz />} />
        <Route path="/submit" element={<ResultSubmission />} />
      </Routes>
    </Router>
  );
}

export default App;
